(()=>{
 'use strict';
 let dispose=()=>{};
 const init=()=>{
 dispose();
 const root=document.querySelector('[data-av-entrance]');
 if(!root)return;
 const lifecycle=new AbortController();
 const on=(target,type,listener,options={})=>target.addEventListener(type,listener,{...options,signal:lifecycle.signal});
 const images=[...root.querySelectorAll('[data-entrance-image]')];
 const choices=[...root.querySelectorAll('[data-entrance-choice]')];
 const links=[...root.querySelectorAll('[data-entrance-link]')];
 const pause=root.querySelector('[data-entrance-pause]');
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const paired=matchMedia('(min-width: 1100px)');
 const header=document.querySelector('[data-av-header]')?.closest('.shopify-section-group-header-group');
 const dock=document.querySelector('[data-av-dock]');
 if(header)header.inert=false;
 let current=-1,requested=0,timer=null,changeTimer=null,inView=null,userPaused=false,reduced=motion.matches,hovered=false;
 const hydrate=image=>{
  image.parentElement.querySelectorAll('source[data-entrance-srcset]').forEach(source=>{source.srcset=source.dataset.entranceSrcset;delete source.dataset.entranceSrcset;});
  if(image.dataset.entranceSrcset){image.srcset=image.dataset.entranceSrcset;delete image.dataset.entranceSrcset;}
  if(image.dataset.entranceSrc){image.src=image.dataset.entranceSrc;delete image.dataset.entranceSrc;image.loading='eager';}
 };
 const commit=index=>{
  const next=(index+1)%images.length;
  const hasNext=paired.matches&&images.length>1&&images[next].complete&&images[next].naturalWidth>0;
  current=index;
  root.classList.toggle('has-paired-slide',Boolean(hasNext));
  images.forEach((el,i)=>{el.classList.toggle('is-active',i===index);el.classList.toggle('is-next',hasNext&&i===next);});
  choices.forEach((el,i)=>el.setAttribute('aria-pressed',String(i===index)));
  links.forEach(el=>{const n=Number(el.dataset.entranceLink);const active=n===index;const secondary=hasNext&&n===next;el.classList.toggle('is-active',active);el.classList.toggle('is-next',secondary);el.tabIndex=active||secondary?0:-1;el.setAttribute('aria-hidden',String(!active&&!secondary));});
  root.classList.remove('is-switching');
  changeTimer=null;
 };
 const show=index=>{
  requested=index;
  const image=images[index];
  if(!image)return;
  hydrate(image);
  if(paired.matches&&images.length>1)hydrate(images[(index+1)%images.length]);
  if(!image.complete||!image.naturalWidth)return;
  if(changeTimer!==null)clearTimeout(changeTimer);
  if(current!==index&&current>=0&&!reduced){
   root.classList.add('is-switching');
   changeTimer=setTimeout(()=>commit(index),180);
  }else commit(index);
 };
 const sync=()=>{
  if(timer!==null)clearInterval(timer);
  timer=null;
  const stopped=userPaused||reduced;
  pause.textContent=stopped?root.dataset.playLabel:root.dataset.pauseLabel;
  pause.setAttribute('aria-label',pause.textContent);
  if(!stopped&&inView&&!document.hidden&&!hovered&&images.length>1){
   timer=setInterval(()=>show((current+1)%images.length),7000);
  }
 };
 images.forEach((image,index)=>on(image,'load',()=>{if(requested===index||(paired.matches&&(requested+1)%images.length===index))show(requested);}));
 show(0);
 root.querySelector('[data-entrance-controls]').hidden=false;
 document.body.classList.add('av-entrance-ready');
 on(pause,'click',()=>{if(reduced)return;userPaused=!userPaused;sync();});
 choices.forEach((button,index)=>on(button,'click',()=>{userPaused=true;show(index);sync();}));
 // Horizontal image gestures leave vertical scrolling, pinch zoom and browser edges native.
 let gesture=null,suppressClickUntil=0;
 on(root,'click',event=>{if(event.target.closest('[data-entrance-link]')&&performance.now()<suppressClickUntil){event.preventDefault();event.stopPropagation();}},{capture:true});
 on(root,'pointerdown',event=>{
  gesture=null;
  if(!event.isPrimary||!['touch','pen'].includes(event.pointerType)||event.target.closest('button,input,select')||(event.target.closest('a')&&!event.target.closest('[data-entrance-link]')))return;
  if(event.clientX<24||event.clientX>innerWidth-24)return;
  gesture={id:event.pointerId,x:event.clientX,y:event.clientY};
 },{passive:true});
 on(root,'pointercancel',()=>{gesture=null;},{passive:true});
 on(root,'pointerup',event=>{
  const start=gesture;gesture=null;
  if(!start||event.pointerId!==start.id)return;
  const dx=event.clientX-start.x,dy=event.clientY-start.y;
  if(Math.abs(dx)<48||Math.abs(dx)<Math.abs(dy)*1.4)return;
  const forward=document.documentElement.dir==='rtl'?dx>0:dx<0;
  suppressClickUntil=performance.now()+500;
  userPaused=true;show((current+(forward?1:-1)+images.length)%images.length);sync();
 },{passive:true});
 const updateVisibility=()=>{
  const rect=root.getBoundingClientRect();
  const headerHeight=header?.getBoundingClientRect().height||0;
  const nextView=rect.bottom>headerHeight&&rect.top<innerHeight;
  if(nextView===inView)return;
  inView=nextView;
  document.body.classList.toggle('av-intro-visible',nextView);
  if(dock){dock.inert=nextView;dock.setAttribute('aria-hidden',String(nextView));}
  sync();
 };
 on(window,'scroll',updateVisibility,{passive:true});
 on(window,'resize',updateVisibility);
 updateVisibility();
 on(root,'focusin',event=>{if(event.target===pause)return;userPaused=true;sync();});
 on(root,'pointerenter',event=>{if(event.pointerType!=='mouse')return;hovered=true;sync();});
 on(root,'pointerleave',event=>{if(event.pointerType!=='mouse')return;hovered=false;sync();});
 on(document,'visibilitychange',sync);
 on(motion,'change',event=>{reduced=event.matches;sync();});
 on(paired,'change',()=>show(current));
 let observer;
 if(typeof IntersectionObserver!=='undefined'){observer=new IntersectionObserver(updateVisibility,{threshold:0});observer.observe(root);}
 dispose=()=>{lifecycle.abort();if(timer!==null)clearInterval(timer);if(changeTimer!==null)clearTimeout(changeTimer);root.classList.remove('is-switching');observer?.disconnect();document.body.classList.remove('av-intro-visible');if(dock){dock.inert=false;dock.removeAttribute('aria-hidden');}};
 sync();
 };
 init();
 document.addEventListener('shopify:section:load',event=>{if(event.target.matches('[data-av-entrance]')||event.target.querySelector('[data-av-entrance]'))init();});
 document.addEventListener('shopify:section:unload',event=>{if(event.target.matches('[data-av-entrance]')||event.target.querySelector('[data-av-entrance]'))dispose();});
})();






